import { getLogger } from "@expert/logging";
import type { ChallengeInfo } from "../api/getChallenge";

export function getChallengeDescription(challenge: ChallengeInfo): string {
    const { challengeType, details } = challenge;

    const target = details[0].conditions.find((c) => c.threshold === "TARGET");
    const limit = details[0].conditions.find((c) => c.threshold === "UPPER_LIMIT");

    if (target == null || limit == null) return getChallengeName(challenge);

    switch (challengeType) {
        case "solo":
            return `Get ${target.targetValue} enrolls with a max of ${limit.targetValue} cancels.`;
        case "team":
            return `The first team to ${target.targetValue} enrolls with a max of ${limit.targetValue} cancels wins.`;
        default:
            return getChallengeName(challenge);
    }
}

function getChallengeName(challenge: ChallengeInfo): string {
    getLogger({ module: "getChallengeDescription", supportTeam: "sales" }).warn(challenge, "Unknown challengeType");
    return challenge.challengeName;
}
